import KnowledgeList from '@/components/Knowledge/KnowledgeList'

const KnowledgeMain = () => {
  return <KnowledgeList />
}

export default KnowledgeMain
